import ApiResourceManager from '../ApiResourceManager';

export default class UserDeletionRequestsManager extends ApiResourceManager {
  get = (params) =>
    this.request({
      method: 'GET',
      url: '/user-deletion-requests',
      params,
    });

  create = (data) =>
    this.request({
      method: 'POST',
      url: '/user-deletion-requests',
      data,
    });

  approve = (id) =>
    this.request({
      method: 'POST',
      url: `/user-deletion-requests/${id}/approve`,
    });
}
